import React, { useState } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import DeleteIcon from "../Icons/delete.svg?react";

const UploadS1 = ({
  className,
  placeholder = "Загрузить",
  label,
  field,
  form: { setFieldValue, errors },
}) => {
  const [image, setImage] = useState("");
  const [file, setFile] = useState(null);

  UploadS1.propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
  };

  UploadS1.defaultProps = {
    label: "",
    className: "",
  };

  const classes = cx(
    "form-field",
    errors[field.name] && "form-field--error",
    className
  );

  const previewFile = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onloadend = function() {
      setImage(reader.result);
    };

    if (file && file.type.match("image.*")) {
      reader.readAsDataURL(file);
    } else {
      setFile(file);
    }
  };

  const clearValue = () => {
    setImage("");
    setFile(null);
    setFieldValue(field.name, "");
  };

  return (
    <div className={classes}>
      {label && <label className="form-field__label">{label}</label>}
      <div className="form-field__upload">
        {image && (
          <div className="form-field__preview">
            <img src={image} alt="" />
            <div className="delete-btn" onClick={clearValue}>
              <DeleteIcon />
            </div>
          </div>
        )}
        {!image && !file && (
          <label className="form-field__upload-mask">
            <span>{placeholder}</span>
            <input
              type="file"
              name={field.name}
              onChange={(event) => {
                setFieldValue(field.name, event.currentTarget.files[0]);
                previewFile(event);
              }}
              className="form-field__upload-input"
            />
          </label>
        )}
        {file && (
          <div>
            <span className="fw-700">Загружена файл: </span>
            {file.name}
            <div
              className="--danger-color text-underline cursor-pointer"
              onClick={clearValue}
            >
              Очистить
            </div>
          </div>
        )}
      </div>
      
    </div>
  );
};

export default UploadS1;
